import list from './list';
import icon from '@mui/icons-material/RequestQuote';

/** Solo lectura: es una consulta de facturacion, no un CRUD. */
const adminConfig = { list, icon };

export default adminConfig;
